// extracted by mini-css-extract-plugin
export default {"recommendedSection":"Recommended_recommendedSection__LqBof","innerContainer":"Recommended_innerContainer__+lJgf","recommended":"Recommended_recommended__N-SPj"};